import { Injectable } from '@angular/core';
import { ExternalMarketing } from '../../shared/models/external-marketing';
import { ProspectModel } from '../../shared/models/ProspectModel';
import { Observable } from 'rxjs';
import { RestService } from '../providers/rest.service';
import { ResultOutputModel } from '../models/resultOutputModel';
import { IPrincipalSellerAdd } from '../models/PrincipalSellerAdd';
import { IResponseModel } from '../../shared/models/ResponseModel';
import { IEditDocumentModel } from '../models/EditDocumentModel';
import { IBulkUpdateModel } from '../models/BulkUpdateModel';

@Injectable()
export class DashboardService extends RestService {

  //// --- External Marketing Start ---///
  saveExternalMarketing(externalMarketing: ExternalMarketing): Observable<ResultOutputModel> {
    return this.postForEntityObject('property/saveExteranalMarketing/', externalMarketing);
  }

  getExternalMarketingSource() {
    return this.GET('property/getExteranalMarketingSource');
  }

  getExternalMarketingListByTypeId(id: number, propertyId: number) {
    return this.GET('property/getExteranalMarketingListByTypeId/' + id + '/' + propertyId);
  }

  removeExternalMarketing(Id: number) {
    return this.get<boolean>('property/removeExteranalMarketing/' + Id);
  }

  getExternalMarketingCount(propertyId: number) {
    return this.GET('property/getExternalMarketingCount/' + propertyId);
  }

  getExternalMarketingCountForPortfolio(propertyId: number) {
    return this.GET('property/getExternalMarketingCountForPortfolio/' + propertyId);
  }

  //// --- External Marketing End ---///

  saveProspects(externalMarketing: ProspectModel): Observable<ResultOutputModel> {
    return this.postForEntityObject('property/saveProspects/', externalMarketing);
  }

  saveEmailForProspects(emailModel: ProspectModel): Observable<boolean> {
    return this.postForEntityObject('property/SaveEmailInProspectMaster/', emailModel);
  }

  saveBulkUpdate(prospects: IBulkUpdateModel): Observable<string> {
    return this.postForEntityObject('salesforce/bulkaddtask/', prospects);
  }

  saveImportProspects(prospects: any): Observable<boolean> {
    return this.postForEntityObject('property/saveImportProspects/', prospects);
  }

  GetMarketingReport(propertyid, period: number) {
    return this.post('property/MarketingReport/' + period, propertyid);
  }
  GetProspectsStatusForDashboard(propertyid: number, period: number) {
    return this.GET('property/prospectsStatusForDashboard/' + propertyid + "/" + period);
  }

  saveSellerVisibilityForProspect(propertyId, status): Observable<ResultOutputModel> {
    return this.postForEntityObject('property/setSellerVisibilityForProspect/' + propertyId + '/' + status, "");
  }

  savePriorityForProspect(prospectId): Observable<ResultOutputModel> {
    return this.postForEntityObject('property/setPriorityForProspect/' + prospectId , "");
  }


  getPropertyPremarketingDetails(propertyId: number) {
    return this.GET('property/getPropertyPremarketingDetails/' + propertyId);
  }

  savePropertyPremarketingStatus(propertyId, statusId, status): Observable<ResultOutputModel> {
    return this.postForEntityObject('property/savePropertyPremarketingStatus/' + propertyId + '/' + statusId + '/' + status, "");
  }

  saveBOEPropertyDocumentCategory(documentId, categoryId, isActive, userId): Observable<ResultOutputModel> {
    return this.postForEntityObject('property/UpdateBOEPropertyDocumentCategory/' + documentId + '/' + categoryId + '/' + isActive + '/' + userId, "");
  }

  EditDocument(editDocumentModel: IEditDocumentModel): Observable<ResultOutputModel> {
    return this.postForEntityObject('property/UpdateDocumentInMyPortfolio/', editDocumentModel);
  }

  GetBOEPropertyDocumentForReview(propertyId) {
    return this.GET('property/GetBOvReviewDocByPropertyId/' + propertyId);
  }

  GetBOVChecklistByPropertyId(propertyId, userid) {
    return this.GET('property/GetBOVChecklistByPropertyId/' + propertyId + '/' + userid);
  }

  saveBOVChecklistByPropertyId(propertyId, categoryId, notes): Observable<ResultOutputModel> {
    return this.postForEntityObject('property/saveBOVChecklistByPropertyId/' + propertyId + '/' + categoryId, notes);
  }

  GetPrevProspectsList(pid, input: any) {
    return this.GET('property/GetPrevProspectsList/' + pid + "/" + input);
  }

  GetProspectDetails(input: any) {
    return this.GET('property/GetProspectDetails/' + input);
  }

  UpdateSalesforceId(propertyId: number, salesforceId: string) {
    return this.GET('salesforce/UpdateSalesforceId/' + propertyId + '/' + salesforceId);
  }

  SavePrincipalFromPropDashboard(principalModal: IPrincipalSellerAdd): Observable<IPrincipalSellerAdd> {
    return this.postForEntityObject('property/Seller/', principalModal);
  }

  GetSellerDetails(pid: any) {
    return this.GET('property/' + pid + '/Seller/');
  }

  deleteSellerFromPropDashboard(propertyId: number, userid: number) {
    return this.delete('property/' + propertyId + '/Seller/' + userid);
  }

  GetUserDetailsByEmailAddress(principalModal: IPrincipalSellerAdd): Observable<IPrincipalSellerAdd> {
    return this.postForEntityObject('user/UserDetails/', principalModal);
  }


}
